export const URL = {
	RECENT_WORK: '/recent-work',
}